import { useEffect, useState } from 'react';
export default function useViewport() {
    var _a = useState(window.innerWidth), width = _a[0], setWidth = _a[1];
    useEffect(function () {
        var handleWindowResize = function () {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleWindowResize);
        return function () {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    // Return the width so we can use it in our components
    return { width: width };
}
